import { gql } from "@apollo/client";

// Queue tiles and their insights need only names, dates and amounts.
export const GET_DASHBOARD_CARD_REQUESTS = gql`
  query dashboardCardRequests($first: Int) {
    pendingCardApproval(first: $first) {
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
          }
          pendingRequest {
            requestDate
          }
        }
      }
    }
  }
`;

export const GET_DASHBOARD_INVOICES = gql`
  query dashboardInvoices($first: Int, $status: [InvoiceStatusEnum]) {
    invoices(first: $first, status: $status) {
      edges {
        node {
          id
          total
          dueDate
          primaryRecipient {
            id
            firstName
            lastName
            businessName
          }
        }
      }
    }
  }
`;
